
import { useRef, useState, useEffect } from 'react'
import { useStaticQuery, graphql, Link } from 'gatsby'

import spriteSvg from '../layout/sprite.svg'
import asfPng from './asf.png'
import livroDeReclamacoesPng from './livro-de-reclamacoes.png'
import SiteLink from './SiteLink'
import Icon from '../utils/Icon'
import Schema from '../utils/Schema'
import breakCategoryLabel from '../utils/breakCategoryLabel'

import '../styles/global.sass'

const SOCIALS = [
	['Facebook',	'facebook',	'https://facebook.com/comparamais.pt'],
	['Instagram',	'instagram','https://www.instagram.com/comparamais/'],
	['LinkedIn',	'linkedin',	'https://pt.linkedin.com/company/comparamais'],
]

const CAMPAIGN_IDS = ['utm_source', 'utm_medium', 'utm_campaign', 'wnr_source', 'aff_id', 'gclid', 'fbclid', 'msclickid']

// function getDarkMode() {
// 	if (typeof window === 'undefined') return false
// 	const darkMode = window.localStorage.getItem('darkMode')
// 	return darkMode === 'true'
// }

export const CAMPAIGN_IDS_STORAGE_KEY = 'comparamais-campaign-ids'


export default function Layout({ children, location }) {

	const [isOpenMenu, setOpenMenu] = useState(false)
	const menuRef = useRef(null)
	// const [darkMode, setDarkMode] = useState(getDarkMode())

	const data = useStaticQuery(graphql`query Categories {
		allCategories(sort: { position: ASC } ) {
			nodes {
				id
				uri { url }
				label
			}
		}
		allLegalPages {
			nodes {
				id
				uri { url }
				label
			}
		}
		taxPage: infoPages(uri: { url: {eq: "/impostos/"}}) {
			uri { url }
			label
		}
		publicServicesPage: infoPages(uri: { url: {eq: "/servicos-publicos/"}}) {
			uri { url }
			label
		}
		savingsPage: infoPages(uri: { url: {eq: "/poupar-dinheiro/"}}) {
			uri { url }
			label
		}
	}`)

	useEffect(() => {
		const searchParams = new URLSearchParams(location.search)
		const attrs = {}
		for (const [key, value] of searchParams.entries())
			if (CAMPAIGN_IDS.includes(key)) 
				attrs[key] = value
		if (Object.keys(attrs).length)
			localStorage.setItem(CAMPAIGN_IDS_STORAGE_KEY, JSON.stringify(attrs))
	}, [location.search])

	useEffect(() => {
		setOpenMenu(false)
	}, [location.pathname])

	useEffect(() => {
		if (!isOpenMenu) return;
		function handleClickOutside(event) {
			if (menuRef.current && !menuRef.current.contains(event.target))
				setOpenMenu(false)
		}
		document.addEventListener("mousedown", handleClickOutside)
		return () => document.removeEventListener("mousedown", handleClickOutside)
	}, [isOpenMenu, location.pathname])

	// useEffect(() => {
	// 	if (darkMode) document.body.classList.add('dark')
	// 		else document.body.classList.remove('dark')
	// 	try {
	// 		window.localStorage.setItem('darkMode', darkMode)			
	// 	} catch (_) {}
	// }, [darkMode])

	return <>
		<span style={{ display: 'none' }}>Impact-Site-Verification: 175f2cc7-0165-40d8-b359-c387016803ec</span>

		<div id='Navbar'>

			<SiteLink />
			
			<nav id='NavbarMenu' className={isOpenMenu ? 'isOpen' : 'isClosed'} ref={menuRef}>
				<button 
					aria-label='Menu' 
					aria-controls='navigation' 
					aria-expanded={isOpenMenu}
					onClick={() => setOpenMenu(v => !v)}
				>
					<Icon i='menu' />
				</button>
				<menu role='navigation'>
					{ data.allCategories?.nodes?.filter(c => c.uri.url !== '/credito-automovel/').map(c => 
						<li key={c.id}>
							<Link key={c.id} 
								to={c.uri.url}
								activeClassName='active'
								partiallyActive={true}
							>
								{ breakCategoryLabel(c.label) }
							</Link>
						</li>
					)}
				</menu>
			</nav>

			<address id='NavbarContact'>
				<Icon i='phone' />
				<a href="tel:210201170">210 201 170</a>
				<span>Seg. a Sex. 9h as 19h</span>
			</address>

		</div>

		{/* <div id='DarkModeBanner' className={darkMode ? 'darkmode-on' : 'darkmode-off'}>
			<div id='DarkModeWrap'>
				<span id='DarkModeText'>Ativar {darkMode ? "Light" : "Dark"} Mode</span>
				<label id='DarkmodeToggle' aria-label="Ativar Dark/Light Mode">
					<input type='checkbox' 
						checked={darkMode}
						onChange={e => {
							setDarkMode(e.target.checked)
							try { 
								window.dataLayer?.push({ event: `DarkMode_${darkMode ? 'ON' : 'OFF'}` })
							} catch (_) {}
						}}
					/>
					<Icon i='lightmode' />
					<Icon i='darkmode' />
					<div className='switch' />
				</label>
			</div>
		</div> */}

		{children}

		<footer id='Footer'>

			<SiteLink />

			<button className='more-button' onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
				Voltar ao topo <Icon i='up' />
			</button>

			<nav id='FooterLinks'>

				<ul className='loans'>{ data.allCategories?.nodes?.map(c => 
					<li key={c.id}><Link to={c.uri.url}>{c.label}</Link></li> 
				)}</ul>

				<ul className='info'>
					<li><Link to={data.taxPage?.uri.url}>{data.taxPage?.label}</Link></li>
					<li><Link to={data.publicServicesPage?.uri.url}>{data.publicServicesPage?.label}</Link></li>
					<li><Link to={data.savingsPage?.uri.url}>{data.savingsPage?.label}</Link></li>
				</ul>
				
				<ul className='legal'>
					<li><Link to='/sobre-nos/'>Sobre Nós</Link></li> 
					{ data.allLegalPages?.nodes?.map(p => 
						<li key={p.id}><Link to={p.uri.url} rel='noindex'>{p.label}</Link></li> 
					)}
				</ul>
			</nav>

			<figure id='FooterBank'>

				{/* <img src={BancoDePortugalSvg} width={204} height={96} alt='Autorizados pelo Banco de Portugal' loading='lazy' /> */}
				<svg xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 204 96" 
					width="204" 
					height="96"  
					alt="Autorizados pelo Banco de Portugal"
				>
					<use href={`${spriteSvg}#banco-de-portugal`} />
				</svg>

				<figcaption>
					Autorizados pelo Banco de Portugal<br />
					<strong>Intermediário de crédito nº00004514</strong>
				</figcaption>
			</figure>

			<section id='FooterCertifications'>
				<a
					href='https://www.asf.com.pt/web/site-asf/mediador?MediadorId=225913'
					rel='nofollow noopener noreferrer'
					target='_blank'
					aria-label='ASF - Autoridade de Supervisão de Seguros e Fundos de Pensões'
				>
					<img src={asfPng} alt='ASF' width={666} height={375} loading='lazy' />
				</a>
				<a
					href='https://www.livroreclamacoes.pt/Inicio/'
					rel='nofollow noopener noreferrer'
					target='_blank'
					aria-label='Livro de Reclamações'
				>
					<img src={livroDeReclamacoesPng} alt='Livro de Reclamações' width={660} height={378} loading='lazy' />
				</a>
			</section>

			<section id='FooterSocials'>
				Segue-nos nas redes sociais<br />
				<ul id='FooterSocials'>
					{ SOCIALS.map(([label, icon, url]) =>
						<li key={label}>
							<a href={url} rel='nofollow noopener noreferrer' aria-label={label}>
								<Icon i={icon} />
							</a>
						</li>
					)}
				</ul>
			</section>

			<section id='FooterCopy'>
				<p>© 2024 para Comparamais.pt. Leap Centre, Escritório E.22, 1250-091 Lisboa, Portugal</p>
			</section>

			<Schema json={{
				'@type': 'Organization',
				name: 'Comparamais.pt',
				url: 'https://www.comparamais.pt/',
				telephone: '+351210201170',
				address: {
					'@type': 'PostalAddress',
					streetAddress: 'Leap Centre, Escritório E.22',
					addressLocality: 'Lisboa',
					postalCode: '1250-091',
					addressCountry: 'PT',
				},
			}} />

		</footer>

	</>
}
